export const GET_CDR = "GET_CDR"
export const GET_CDR_SUCCESS = "GET_CDR_SUCCESS"
export const GET_CDR_FAIL = "GET_CDR_FAIL"
